import svg from './row-svg/cross-v1.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function CrossV1Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default CrossV1Icon;
